/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Joinbeta2Inputs */

const id_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bergabung dengan Beta di Google Play`)
};

const ms_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertai Beta di Google Play`)
};

const da_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deltag i Beta på Google Play`)
};

const de_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta auf Google Play beitreten`)
};

const en_us2_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Beta on Google Play`)
};

const es_es2_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a la Beta en Google Play`)
};

const es_mx2_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a la Beta en Google Play`)
};

const fil_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumali sa Beta sa Google Play`)
};

const fr_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre la bêta sur Google Play`)
};

const it_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partecipa alla Beta su Google Play`)
};

const hu_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csatlakozz a Bétához a Google Play-en`)
};

const nl_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deelnemen aan de Bèta op Google Play`)
};

const no_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bli med i Beta på Google Play`)
};

const pl_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dołącz do bety w Google Play`)
};

const pt_br2_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Beta on Google Play`)
};

const pt_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juntar-se à Beta no Google Play`)
};

const ro_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alătură-te Betai pe Google Play`)
};

const fi_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liity betaan Google Playssa`)
};

const sv_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå med i Betan på Google Play`)
};

const vi_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham gia Beta trên Google Play`)
};

const tr_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play'de Beta'ya Katıl`)
};

const cs_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojit se k beta na Google Play`)
};

const bg_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присъединете се към Beta в Google Play`)
};

const ru_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присоединиться к бета-тесту в Google Play`)
};

const uk_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приєднатися до Beta в Google Play`)
};

const ar_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انضم إلى الإصدار التجريبي على Google Play`)
};

const hi_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play पर शामिल हों`)
};

const th_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าร่วมเบต้าบน Google Play`)
};

const ja_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play でベータ版に参加`)
};

const zh_cn2_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Beta on Google Play`)
};

const zh_hant1_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Beta on Google Play`)
};

const ko_forms_androidbeta_joinbeta2 = /** @type {(inputs: Forms_Androidbeta_Joinbeta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Beta on Google Play`)
};

/**
* | output |
* | --- |
* | "Join the Beta on Google Play" |
*
* @param {Forms_Androidbeta_Joinbeta2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_joinbeta2 = /** @type {((inputs?: Forms_Androidbeta_Joinbeta2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Joinbeta2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_joinbeta2(inputs)
	if (locale === "ms") return ms_forms_androidbeta_joinbeta2(inputs)
	if (locale === "da") return da_forms_androidbeta_joinbeta2(inputs)
	if (locale === "de") return de_forms_androidbeta_joinbeta2(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_joinbeta2(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_joinbeta2(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_joinbeta2(inputs)
	if (locale === "fil") return fil_forms_androidbeta_joinbeta2(inputs)
	if (locale === "fr") return fr_forms_androidbeta_joinbeta2(inputs)
	if (locale === "it") return it_forms_androidbeta_joinbeta2(inputs)
	if (locale === "hu") return hu_forms_androidbeta_joinbeta2(inputs)
	if (locale === "nl") return nl_forms_androidbeta_joinbeta2(inputs)
	if (locale === "no") return no_forms_androidbeta_joinbeta2(inputs)
	if (locale === "pl") return pl_forms_androidbeta_joinbeta2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_joinbeta2(inputs)
	if (locale === "pt") return pt_forms_androidbeta_joinbeta2(inputs)
	if (locale === "ro") return ro_forms_androidbeta_joinbeta2(inputs)
	if (locale === "fi") return fi_forms_androidbeta_joinbeta2(inputs)
	if (locale === "sv") return sv_forms_androidbeta_joinbeta2(inputs)
	if (locale === "vi") return vi_forms_androidbeta_joinbeta2(inputs)
	if (locale === "tr") return tr_forms_androidbeta_joinbeta2(inputs)
	if (locale === "cs") return cs_forms_androidbeta_joinbeta2(inputs)
	if (locale === "bg") return bg_forms_androidbeta_joinbeta2(inputs)
	if (locale === "ru") return ru_forms_androidbeta_joinbeta2(inputs)
	if (locale === "uk") return uk_forms_androidbeta_joinbeta2(inputs)
	if (locale === "ar") return ar_forms_androidbeta_joinbeta2(inputs)
	if (locale === "hi") return hi_forms_androidbeta_joinbeta2(inputs)
	if (locale === "th") return th_forms_androidbeta_joinbeta2(inputs)
	if (locale === "ja") return ja_forms_androidbeta_joinbeta2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_joinbeta2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_joinbeta2(inputs)
	return ko_forms_androidbeta_joinbeta2(inputs)
});
export { forms_androidbeta_joinbeta2 as "forms.androidBeta.joinBeta" }